/** Autor editorial público del blog (UI + schema.org). */
const BLOG_AUTHOR_DISPLAY = 'Equipo Coolliving';

const LEGACY_BLOG_AUTHOR_ALIASES = new Set([
  'coolliving.io',
  'Coolliving',
  'Jaime Martínez',
  'Jaime Martinez',
]);

function normalizeBlogAuthor(authorName) {
  const raw = (authorName || '').trim();
  if (!raw || LEGACY_BLOG_AUTHOR_ALIASES.has(raw)) return BLOG_AUTHOR_DISPLAY;
  return raw;
}

function getEquipoCoollivingAuthorSchema() {
  return {
    '@type': 'Organization',
    name: BLOG_AUTHOR_DISPLAY,
    url: 'https://coolliving.io/sobre-nosotros',
    parentOrganization: {
      '@type': 'Organization',
      name: 'Coolliving',
      url: 'https://coolliving.io',
      logo: 'https://coolliving.io/images/favicon.jpg',
    },
  };
}

module.exports = {
  BLOG_AUTHOR_DISPLAY,
  normalizeBlogAuthor,
  getEquipoCoollivingAuthorSchema,
};
